
import {
  Component,
  Vue,
} from 'vue-property-decorator';
import { ReservationItemModule } from '@/store/modules/reservationItem';

@Component({
  name: 'ApplicationInfoForm',
})
export default class extends Vue {
  get clientFields() {
    return ReservationItemModule.form.clientFields;
  }
}
